const reNotDigits = new RegExp(/\D/g);

export const sortOffers = (offers: Array<GM.GuestAcquisition.OfferDTO>) => {
  return [...offers.sort((a, b) => {
    const a_ = parseInt(a.version.replace(reNotDigits, ''), 10);
    const b_ = parseInt(b.version.replace(reNotDigits, ''), 10);

    return -(b_ - a_);
  })];
};

export const matchRestaurantOffer = (
  offer: GM.GuestAcquisition.OfferDTO,
  restaurantSettings: GM.GuestAcquisition.RestaurantSettingsDTO | null,
): GM.GuestAcquisition.SettingsOfferDTO => {
  return restaurantSettings?.offers?.find(
    (restaurantOffer) => restaurantOffer.offer.id === offer.id,
  );
}

export const isOfferAccepted = (
  offer: GM.GuestAcquisition.OfferDTO | null,
  restaurantSettings: GM.GuestAcquisition.RestaurantSettingsDTO | null,
): boolean => {
  return offer && !!matchRestaurantOffer(offer, restaurantSettings);
};

export const isAvailableToWork = (
  latestOffer: GM.GuestAcquisition.OfferDTO | null,
  restaurantSettings: GM.GuestAcquisition.RestaurantSettingsDTO | null,
  requiredEmptyAttributes: Array<string>,
): boolean => {
  return isOfferAccepted(latestOffer, restaurantSettings) && requiredEmptyAttributes.length === 0;
};
